"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRouter = require("react-router");
var R = _interopRequireWildcard(require("ramda"));
var _reactRedux = require("react-redux");
var _reactDeviceDetect = require("react-device-detect");
var _reactScroll = require("react-scroll");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _selectors = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _helpers2 = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var _selectors4 = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors5 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _selectors6 = require("@otpusk/apisearch-toolbox/dist/reviews/selectors");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _config = require("../../../../services/config");
var _pluralTranslations = require("../../../../localization/pluralTranslations");
var _external = require("../../../../bus/external");
var _selectors7 = require("../../../../bus/stats/selectors");
var _selectors8 = require("../../../collections/store/selectors");
var _Alert = _interopRequireWildcard(require("../../../ui/Alert"));
var _PriceChart = _interopRequireDefault(require("../PriceChart"));
var _Segment = require("../../../ui/Segment");
var _book = require("../../../routes/book");
var _actions = require("./store/actions");
var _selectors9 = require("./store/selectors");
var _Hotel = _interopRequireDefault(require("../Hotel"));
var _Stat = _interopRequireDefault(require("./components/Stat"));
var _Info = _interopRequireDefault(require("./components/Info"));
var _Order = require("./components/Order");
var _Reviews = _interopRequireDefault(require("./components/Reviews"));
var _Description = _interopRequireDefault(require("./components/Description"));
var _Transports = _interopRequireDefault(require("./components/Transports"));
var _BookingServices = require("./components/BookingServices");
var _AdditionalHotelInfo = require("./components/AdditionalHotelInfo");
var _IntegrationServices = require("./components/IntegrationServices");
var _DescriptionByAI = require("./components/DescriptionByAI");
var _selectors10 = require("./components/Order/store/selectors");
var _helpers3 = require("./helpers");
var _constants = require("./constants");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var OfferDetails = function OfferDetails(_ref) {
  var _actualizedOffer$addi, _actualizedOffer$adul, _actualizedOffer$flig, _actualizedOffer$isTr, _actualizedOffer$peop, _actualizedOffer$subO, _actualizedOffer$subO2, _offer$subOperator, _actualizedOffer$requ, _actualizedOffer$incl, _actualizedOffer$room, _actualizedOffer$room2, _offer$room, _actualizedOffer$hote, _actualizedOffer$id;
  var isModalMode = _ref.isModalMode,
    hotelID = _ref.hotelID,
    mbOfferKey = _ref.offerID,
    queryID = _ref.queryID,
    onClickByChartBar = _ref.onClickByChartBar,
    onOpenMap = _ref.onOpenMap,
    className = _ref.className;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var touristsTranslation = (0, _pluralTranslations.usePluralTouristsTranslation)();
  var actualizedOfferSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors2.getActualizedOffer)(), [{
      offerID: mbOfferKey
    }]);
  }, [mbOfferKey]);
  var offerSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors2.getOffer)(), [{
      offerID: mbOfferKey
    }]);
  }, [mbOfferKey]);
  var hotelSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors.getHotel)(), [hotelID]);
  }, [hotelID]);
  var isFailFetchingReviewsSelector = (0, _react.useMemo)(function () {
    return R.partialRight((0, _selectors9.isFailFetchingReviews)(), [{
      hotelID: hotelID
    }]);
  }, [hotelID]);
  var shouldRenderAddToCollectionButton = (0, _reactRedux.useSelector)(_selectors8.isEnabledCollectionsFeature);
  var _useSelector = (0, _reactRedux.useSelector)(_selectors10.getUIOfActualizingOffer),
    isActualazing = _useSelector.loading;
  var isAlive = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.isAliveOffer)(state, {
      offerID: mbOfferKey
    });
  });
  var isFailFetchingReviews = (0, _reactRedux.useSelector)(isFailFetchingReviewsSelector);
  var actualizedOffer = (0, _reactRedux.useSelector)(actualizedOfferSelector);
  var offer = (0, _reactRedux.useSelector)(offerSelector);
  var hotel = (0, _reactRedux.useSelector)(hotelSelector);
  var labels = (0, _reactRedux.useSelector)(_selectors3.getLabels);
  var integrationServices = (0, _reactRedux.useSelector)(_selectors9.getIntegrationServices);
  var activeCurrency = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors5.getQueryParam)(state, {
      queryID: queryID,
      paramName: _fn.QUERY_PARAMS.CURRENCY
    });
  });
  var operatorSelector = (0, _react.useMemo)(function () {
    return (offer === null || offer === void 0 ? void 0 : offer.operator) ? R.partialRight((0, _selectors4.getOperator)(), [{
      operatorID: offer.operator,
      key: (0, _helpers.generateOperatorKey)(hotel.country.id, offer.departure)
    }]) : R.always(undefined);
  }, [hotel.country.id, offer]);
  var operator = (0, _reactRedux.useSelector)(operatorSelector);
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return operator ? (0, _external.getBookingTypes)(state, {
        operatorID: operator.id
      }) : {};
    }),
    isBookingByOwn = _useSelector2.isBookingByOwn;
  var turpravdaWidget = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors6.getTurpravdaWidget)(state, {
      hotelID: hotelID
    });
  });
  var hotelStatsByBooking = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors7.getHotelStatsByBooking)(state, {
      hotelID: hotelID
    });
  });
  var currency = (0, _react.useMemo)(function () {
    return (0, _dictionary.getCurrencyByCode)(activeCurrency);
  }, [activeCurrency]);
  var _useMemo = (0, _react.useMemo)(function () {
      return R.has('year', hotelStatsByBooking) ? [(0, _helpers3.getTextByYearBookings)(hotelStatsByBooking.year), (0, _helpers3.getSubTextByYearBookings)(hotelStatsByBooking.year, touristsTranslation)] : [];
    }, [hotelStatsByBooking, touristsTranslation]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    bookingsInfoByYear = _useMemo2[0],
    touristsInfoByYear = _useMemo2[1];
  var offerID = (0, _helpers2.isOfferKey)(mbOfferKey) ? (0, _helpers2.extractDataFromOfferKey)(mbOfferKey).id : mbOfferKey;
  var isHotelPage = (0, _reactRouter.matchPath)(global.location.pathname, {
    path: _book.book.hotel
  });

  // combined data
  var additionalPayments = (_actualizedOffer$addi = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.additionalPayments) !== null && _actualizedOffer$addi !== void 0 ? _actualizedOffer$addi : offer === null || offer === void 0 ? void 0 : offer.additionalPayments;
  var adults = (_actualizedOffer$adul = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.adults) !== null && _actualizedOffer$adul !== void 0 ? _actualizedOffer$adul : offer === null || offer === void 0 ? void 0 : offer.adults;
  var flights = (_actualizedOffer$flig = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.flights) !== null && _actualizedOffer$flig !== void 0 ? _actualizedOffer$flig : offer === null || offer === void 0 ? void 0 : offer.flights;
  var isTransportGDS = (_actualizedOffer$isTr = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.isTransportGDS) !== null && _actualizedOffer$isTr !== void 0 ? _actualizedOffer$isTr : offer === null || offer === void 0 ? void 0 : offer.isTransportGDS;
  var people = (_actualizedOffer$peop = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.people) !== null && _actualizedOffer$peop !== void 0 ? _actualizedOffer$peop : offer === null || offer === void 0 ? void 0 : offer.people;
  var subOperatorName = (_actualizedOffer$subO = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : (_actualizedOffer$subO2 = actualizedOffer.subOperator) === null || _actualizedOffer$subO2 === void 0 ? void 0 : _actualizedOffer$subO2.name) !== null && _actualizedOffer$subO !== void 0 ? _actualizedOffer$subO : offer === null || offer === void 0 ? void 0 : (_offer$subOperator = offer.subOperator) === null || _offer$subOperator === void 0 ? void 0 : _offer$subOperator.name;
  var requirements = (_actualizedOffer$requ = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.requirements) !== null && _actualizedOffer$requ !== void 0 ? _actualizedOffer$requ : offer === null || offer === void 0 ? void 0 : offer.requirements;
  var includes = (_actualizedOffer$incl = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.includes) !== null && _actualizedOffer$incl !== void 0 ? _actualizedOffer$incl : offer === null || offer === void 0 ? void 0 : offer.includes;
  var roomName = (_actualizedOffer$room = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : (_actualizedOffer$room2 = actualizedOffer.room) === null || _actualizedOffer$room2 === void 0 ? void 0 : _actualizedOffer$room2.name) !== null && _actualizedOffer$room !== void 0 ? _actualizedOffer$room : offer === null || offer === void 0 ? void 0 : (_offer$room = offer.room) === null || _offer$room === void 0 ? void 0 : _offer$room.name;
  var hotelNameByOperator = (_actualizedOffer$hote = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.hotelNameByOperator) !== null && _actualizedOffer$hote !== void 0 ? _actualizedOffer$hote : offer === null || offer === void 0 ? void 0 : offer.hotelNameByOperator;
  var onBooking = (0, _react.useCallback)(function () {
    _reactScroll.scroller.scrollTo(_constants.DESCRIPTION_ID, {
      duration: 500,
      delay: 0,
      smooth: true,
      isDynamic: true,
      offset: 0.6,
      containerId: isModalMode ? _constants.OFFER_DETAILS_MODAL_ID : undefined
    });
  }, [isModalMode]);
  var onCurrencyChange = (0, _react.useCallback)(function (nextCurrencyCode) {
    return dispatch((0, _actions.changeCurrencyCode)(nextCurrencyCode, offerID, queryID));
  }, [dispatch, offerID, queryID]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.root, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.grid
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.hotelContainer
  }, /*#__PURE__*/_react.default.createElement(_Hotel.default, {
    isShowOpenOfferButton: !!offerID,
    averageRating: hotel.averageRating,
    city: hotel.city,
    country: hotel.country,
    currency: activeCurrency,
    district: hotel.district,
    hotelID: hotelID,
    isEnabledCollectionsFeature: shouldRenderAddToCollectionButton,
    isMobile: _reactDeviceDetect.isMobileOnly,
    name: hotel.name,
    offerID: offerID,
    photo: hotel.photos[0],
    secondaryStars: hotel.secondaryStars,
    services: hotel.services,
    sourceRatings: hotel.sourceRatings,
    stars: hotel.stars,
    watermark: hotel.watermark,
    onOpenMap: hotel.location ? onOpenMap : undefined
  }), hotelStatsByBooking && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.statList
  }, hotelStatsByBooking.all && /*#__PURE__*/_react.default.createElement(_Stat.default, null, t('HOTEL_STATS_BY_BOOKING_TEXT', {
    countBookings: hotelStatsByBooking.all.bookings,
    countryName: R.path(['names', 'pr'], hotel.country)
  })), hotelStatsByBooking.year && /*#__PURE__*/_react.default.createElement(_Stat.default, null, /*#__PURE__*/_react.default.createElement("strong", null, bookingsInfoByYear), touristsInfoByYear && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ' ', touristsInfoByYear)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.descriptionContainer
  }, /*#__PURE__*/_react.default.createElement(_Description.default, {
    description: hotel.description,
    hotelServicesDescription: hotel.info,
    queryID: queryID,
    servicesLabels: labels
  }), (0, _config.getIsEnabledHotelDescriptionByAI)() && hotel.descriptionByAI.data && /*#__PURE__*/_react.default.createElement(_DescriptionByAI.DescriptionByAI, {
    description: hotel.descriptionByAI.data
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.offerContainer
  }, offer ? /*#__PURE__*/_react.default.createElement(_Segment.Segment, {
    loading: isActualazing,
    className: _styles.default.offerContent
  }, /*#__PURE__*/_react.default.createElement(_Info.default, {
    adults: people.adults,
    adultsFromOperator: adults,
    child: people.children,
    currency: activeCurrency,
    flights: flights,
    foodFullName: offer.foodFullName,
    includes: includes,
    informationOfCrossTour: offer.isCrossTour ? offer.informationOfCrossTour : undefined,
    nights: offer.nights,
    nightsInHotel: offer.nightsInHotel,
    requirements: requirements,
    room: roomName,
    onCurrencyChange: isAlive ? onCurrencyChange : undefined
  }), /*#__PURE__*/_react.default.createElement(_Transports.default, {
    isTransportGDS: isTransportGDS,
    flights: flights,
    nights: offer.nights,
    startDate: offer.date,
    transport: offer.transport
  }), isBookingByOwn && (0, _config.getIsEnabledBookingServices)() && /*#__PURE__*/_react.default.createElement(_BookingServices.BookingServices, {
    offerID: (_actualizedOffer$id = actualizedOffer === null || actualizedOffer === void 0 ? void 0 : actualizedOffer.id) !== null && _actualizedOffer$id !== void 0 ? _actualizedOffer$id : offerID,
    queryID: queryID
  }), !R.isEmpty(integrationServices) && isBookingByOwn && /*#__PURE__*/_react.default.createElement(_IntegrationServices.IntegrationServices, null), /*#__PURE__*/_react.default.createElement(_Order.Order, {
    additionalPayments: additionalPayments,
    className: _styles.default.order,
    countryID: hotel.country.id,
    currency: currency,
    hotelID: hotelID,
    isHeightPromo: Boolean(offer.heightPromo),
    includes: includes,
    lastUpdateTime: offer.updateTime,
    offerID: mbOfferKey,
    offerTTLAsMinutes: operator === null || operator === void 0 ? void 0 : operator.offerTTLAsMinutes,
    operator: operator,
    price: offer.price[activeCurrency],
    promoText: offer.promo || offer.heightPromo || undefined,
    requirements: requirements,
    subOperatorName: subOperatorName,
    queryID: queryID,
    onBooking: onBooking
  })) : !isHotelPage && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default.alert,
    type: _Alert.TYPES.ERROR
  }, t('NOT_FOUND_OFFER_TEXT', {
    offerID: offerID
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.chartContainer
  }, /*#__PURE__*/_react.default.createElement(_PriceChart.default, {
    currency: currency,
    daysDuration: 13,
    nights: offer === null || offer === void 0 ? void 0 : offer.nights,
    queryID: queryID,
    onClickByBar: onClickByChartBar
  })), /*#__PURE__*/_react.default.createElement(_Reviews.default, {
    averageRating: hotel.averageRating,
    hotelID: hotelID,
    shouldRenderError: isFailFetchingReviews,
    sourceRatings: hotel.sourceRatings,
    turpravdaWidget: turpravdaWidget
  }), !R.isEmpty(hotel.alternativeNames) && /*#__PURE__*/_react.default.createElement(_AdditionalHotelInfo.AdditionalHotelInfo, {
    className: _styles.default.additionalHotelInfo,
    title: t('HOTEL_ALTERNATIVE_NAMES_TITLE')
  }, ': ', R.join(', ', hotel.alternativeNames)), hotelNameByOperator && /*#__PURE__*/_react.default.createElement(_AdditionalHotelInfo.AdditionalHotelInfo, {
    className: _styles.default.additionalHotelInfo,
    title: t('HOTEL_SOURCE_NAME_TITLE')
  }, ': ', hotelNameByOperator))));
};
OfferDetails.propTypes = {
  className: _propTypes.default.string,
  hotelID: _propTypes.default.number.isRequired,
  offerID: _propTypes.default.string,
  queryID: _propTypes.default.string.isRequired,
  isModalMode: _propTypes.default.bool,
  onClickByChartBar: _propTypes.default.func,
  onOpenMap: _propTypes.default.func
};
OfferDetails.defaultProps = {
  queryID: _constants.QUERY_ID_FOR_OFFER_DETAILS,
  isModalMode: false
};
var _default = exports.default = OfferDetails;